import { useRouter } from 'next/router';
import { useEffect } from 'react';

// TODO GRISPI-453 - implement better UI instaed default prompt popup [GRISPI-453]
// const openNotification = async () => {
//     const key = `open${Date.now()}`;
//     const btn = (
//         <Button type="primary" size="small" onClick={() => notification.close(key)}>
//             Confirm
//         </Button>
//     );
//     notification.open({
//         message: 'Notification Title',
//         description:
//             'A function will be be called after the notification is closed (automatically after the "duration" time of manually).',
//         btn,
//         key,
//         onClose: close,
//     });
// };

export default function useAlertOnRefresh(): void {
    const { asPath } = useRouter();

    useEffect(() => {
        window.addEventListener('beforeunload', alertUser);
        window.addEventListener('unload', removeNewTicketsInfo);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
            window.removeEventListener('unload', removeNewTicketsInfo);
        };
    }, [asPath]);

    const alertUser = (e) => {
        const storageItemKeys = Object.keys(sessionStorage)
            .filter(
                (key) =>
                    key.includes('/tickets/new') ||
                    key.includes('/TICKET') ||
                    key.includes('/USER') ||
                    key.includes('/ORGANIZATION')
            )
            .filter((key) => !key.includes('options'));

        if (storageItemKeys.length > 0) {
            e.preventDefault();

            e.returnValue = '';
        }

        // We need to prevent refresh token process to trigger during browser navigation. Because, some of the async HTTP requests (related with current page) might be cancelled which are started during the event 'beforeunload' and they can cause next-auth session and GRISPI-APP authentication control flow to fail. In order to that, we set the stop all request flag to true, so that all requests will be stopped and the refresh token process will not be triggered in case the access token is expired. We will set the flag back to false after the event 'beforeunload' is completed.
        // setLocalStorageItem(StorageHelperKeys.STOP_ALL_REQUEST, true);
    };

    const removeNewTicketsInfo = (_e) => {
        const storageItemKeys = Object.keys(sessionStorage).filter(
            (key) =>
                key.includes('/tickets/new') ||
                key.includes('/TICKET') ||
                key.includes('/USER') ||
                key.includes('/ORGANIZATION')
        );

        storageItemKeys.forEach((itemKey) => {
            sessionStorage.removeItem(itemKey);
        });

        // Now, we can safely let all the requests to be sent to the server. We need to set the stop all request flag to false here, so that we're able to let refresh token process to trigger to do his job as usual, in case the access token is expired.
        // setLocalStorageItem(StorageHelperKeys.STOP_ALL_REQUEST, false);
    };
}
